import {Component, OnInit, ViewChild} from '@angular/core';
import {Api, User} from "../../providers";
import {ModalController} from "@ionic/angular";
import {PostPage} from "../post/post.page";

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.page.html',
  styleUrls: ['./edit-user.page.scss'],
})
export class EditUserPage implements OnInit {
  public img:string;
  public imgsrc:string;
  public name:string;
  public userName:string;
  public phone:string;
  public data:any={};
  public file:File;
  @ViewChild('myinp',{static:true}) public myinp: any;

  constructor(public api:Api, public user: User,public modalController: ModalController)  {

    console.log(user)
  }

  ngOnInit() {
    this.imgsrc=`https://aramis.app/static/users/${this.img}.jpg`
  }
  public dismissModal() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'img':this.img,
      'imgsrc':this.imgsrc,
      'name':this.name,
      'data':this.data,
      'userName':this.userName,
      'phone':this.phone,
      'dismissed': true
    });
  }
  showInput(){
      this.myinp.nativeElement.click();
  }
  changeListener(event){
    if (event.target.files && event.target.files[0]) {
      this.file= event.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event:any) => { // called once readAsDataURL is completed

        this.imgsrc = event.target.result;
      }
      this.uploadImageData();
    }
  }
  async uploadImageData() {
    const formData = new FormData();
    formData.append("thumbnail", this.file);
    formData.append("userKey", this.user.account.userKey);
    formData.append("vr", this.user.account.version);
    await this.user.myLoading()

    const upload$ = this.api.post("profileImage", formData).subscribe(mres => {
        this.user.checkStatus(mres,res=> {
            this.img = mres["data"]["img"]
            this.user.ST.setItem('img', this.img);
            this.user.getUser()
            this.user.dismissLoading()
        },res=>{})
    },err=>{
      this.user.dismissLoading()
    });

  }
  exitUser(){
    this.user.myAlert('', 'آیا می خواهید خارج شوید' , [
      {
        text: 'بیخیال',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      },
      {
        text: 'خروج',
        handler: () => {
          this.user.clear();
          document.location.href = '/welcome';
        }
      }
    ])
    
  }
  async save(){
    const formData = new FormData();
    formData.append("userKey", this.user.account.userKey);
    formData.append("vr", this.user.account.version);
    formData.append("name", this.data.name);
    formData.append("phone", this.data.phone);
    formData.append("userName", this.data.userName);
    formData.append("des", this.data.des || '');
    formData.append("link", this.data.link || '');
    await this.user.myLoading()

    const upload$ = this.api.post("profile/save", formData).subscribe(mres => {
        this.user.checkStatus(mres,res=> {
            this.user.dismissLoading()
            if(res.status=="0"){
            this.user.ST.setItem('name', this.data.name);
            this.user.getUser()
            this.dismissModal()
            }else{
              this.user.myToast(res.message)
            }
            
        },res=>{})
    },err=>{
      this.user.dismissLoading()
    });
  }
}
